import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsAssociateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-associate',
	path: '/secure/admin/AssociateFieldToScreens!default.jspa',
};
